import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-228ef5e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "card-body p-9 pb-12" }
const _hoisted_5 = { class: "panel border border-dashed rounded-3 px-8 border-gray-300 mb-5" }
const _hoisted_6 = { class: "d-flex flex-row justify-content-between align-items-center py-5" }
const _hoisted_7 = { class: "title d-flex flex-column justify-content-start" }
const _hoisted_8 = { class: "m-0 fs-6" }
const _hoisted_9 = { class: "text-gray-400 fs-7 m-0" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tools d-flex flex-row justify-content-end align-items-center" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed mb-0" }, null, -1))
const _hoisted_12 = { class: "row align-items-start gy-5 py-5" }
const _hoisted_13 = { class: "col-md-4" }
const _hoisted_14 = { class: "m-0 fs-6 lh-1" }
const _hoisted_15 = { class: "text-gray-400 fs-7" }
const _hoisted_16 = { class: "col-md-4" }
const _hoisted_17 = { class: "m-0 fs-6 lh-1" }
const _hoisted_18 = { class: "text-gray-400 fs-7" }
const _hoisted_19 = { class: "col-md-4" }
const _hoisted_20 = { class: "m-0 fs-6 lh-1" }
const _hoisted_21 = { class: "text-gray-400 fs-7" }
const _hoisted_22 = { class: "col-md-4" }
const _hoisted_23 = { class: "m-0 fs-6 lh-1" }
const _hoisted_24 = { class: "text-gray-400 fs-7" }
const _hoisted_25 = { class: "col-md-4" }
const _hoisted_26 = { class: "m-0 fs-6 lh-1" }
const _hoisted_27 = { class: "text-gray-400 fs-7" }
const _hoisted_28 = { class: "col-md-4" }
const _hoisted_29 = { class: "m-0 fs-6 lh-1" }
const _hoisted_30 = { class: "text-gray-400 fs-7" }
const _hoisted_31 = { class: "col-md-4" }
const _hoisted_32 = { class: "m-0 fs-6 lh-1" }
const _hoisted_33 = { class: "text-gray-400 fs-7" }
const _hoisted_34 = { class: "col-md-4" }
const _hoisted_35 = { class: "m-0 fs-6 lh-1" }
const _hoisted_36 = { class: "text-gray-400 fs-7" }
const _hoisted_37 = { class: "col-md-4" }
const _hoisted_38 = { class: "m-0 fs-6 lh-1" }
const _hoisted_39 = { class: "text-gray-400 fs-7" }
const _hoisted_40 = { class: "col-md-4" }
const _hoisted_41 = { class: "m-0 fs-6 lh-1" }
const _hoisted_42 = { class: "svg-icon svg-icon-3 ms-1 text-primary" }
const _hoisted_43 = { class: "text-gray-400 fs-7" }
const _hoisted_44 = { class: "col-md-4" }
const _hoisted_45 = { class: "m-0 fs-6 lh-1" }
const _hoisted_46 = { class: "text-gray-400 fs-7" }
const _hoisted_47 = { class: "col-md-4" }
const _hoisted_48 = { class: "m-0 fs-6 lh-1" }
const _hoisted_49 = { class: "text-gray-400 fs-7" }
const _hoisted_50 = { class: "col-md-12" }
const _hoisted_51 = { class: "m-0 fs-6 lh-1" }
const _hoisted_52 = { class: "text-gray-400 fs-7" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", null, _toDisplayString(_ctx.t("payment.refundInfo")), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("h3", _hoisted_8, _toDisplayString(_ctx.t("payment.refund")), 1),
            _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t("payment.updateBy")) + ": " + _toDisplayString(_ctx.baseData.updated_by) + " | " + _toDisplayString(_ctx.$t("payment.updateAt")) + ": " + _toDisplayString(_ctx.formatUtcDate(_ctx.baseData.updated_at, "YYYY-MM-DD")), 1)
          ]),
          _hoisted_10
        ]),
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.baseData.refund_order_no), 1),
            _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.t("payment.refundOrderNo")), 1)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.$currency.currency(_ctx.baseData.amount, 2, ",", ".", "‌€ ")), 1),
            _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.t("payment.refundAmount")), 1)
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.baseData.__show.platform), 1),
            _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.t("payment.paymentPlatform")), 1)
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("p", _hoisted_23, _toDisplayString(_ctx.baseData.customer_name || "--"), 1),
            _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.t("payment.customer")), 1)
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("p", _hoisted_26, _toDisplayString(_ctx.baseData.refund_trade_no || "--"), 1),
            _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.t("payment.refundTradeNo")), 1)
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("p", _hoisted_29, _toDisplayString(_ctx.baseData.refund_platform_trade_no || "--"), 1),
            _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.t("payment.refundPlatformTradeNo")), 1)
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("p", _hoisted_32, _toDisplayString(_ctx.formatDateTime(_ctx.baseData.created_at)), 1),
            _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.t("payment.createdAt")), 1)
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("p", _hoisted_35, _toDisplayString(_ctx.baseData.refund_time
                  ? _ctx.formatDateTime(_ctx.baseData.refund_time)
                  : "--"), 1),
            _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.t("payment.refundTime")), 1)
          ]),
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("p", _hoisted_38, _toDisplayString(_ctx.baseData.refund_method ? _ctx.baseData.__show.refund_method : "--"), 1),
            _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.t("payment.refundMethod")), 1)
          ]),
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("p", _hoisted_41, [
              _createVNode(_component_router_link, {
                to: 
                  '/payment-management/payment/' +
                  _ctx.baseData.payment_id +
                  '/overview'
                ,
                class: "d-flex flex-row align-items-center fw-bolder link"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.baseData.payment_order_no) + " ", 1),
                  _createElementVNode("span", _hoisted_42, [
                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/coding/cod007.svg" })
                  ])
                ]),
                _: 1
              }, 8, ["to"])
            ]),
            _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.t("payment.paymentOrderNo")), 1)
          ]),
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("p", _hoisted_45, _toDisplayString(_ctx.baseData.sales_order_no ? _ctx.baseData.sales_order_no : "--"), 1),
            _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.t("payment.salesOrderNo")), 1)
          ]),
          _createElementVNode("div", _hoisted_47, [
            _createElementVNode("p", _hoisted_48, [
              _createElementVNode("span", {
                class: _normalizeClass(["badge", _ctx.getStatusClass(_ctx.baseData.status)])
              }, _toDisplayString(_ctx.baseData.__show.status), 3)
            ]),
            _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.t("payment.status")), 1)
          ]),
          _createElementVNode("div", _hoisted_50, [
            _createElementVNode("p", _hoisted_51, _toDisplayString(_ctx.baseData.reason), 1),
            _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.t("payment.reason")), 1)
          ])
        ])
      ])
    ])
  ])), [
    [_directive_loading, _ctx.loading]
  ])
}